export default __webpack_public_path__ + "static/media/dot-plot-number-line-blue.b755d6e1.svg";